module.exports = __webpack_public_path__ + "static/user-testing-field-guide@2x-e72aaea3e07863ba09a4c1e5b3121cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/user-testing-field-guide@2x.png
// module id = 2700
// module chunks = 157636680307020